<div class="min-h-screen max-h-screen min-w-screen max-w-screen bg-white overflow-hidden">
    <div class="flex items-center justify-center flex-col h-[40vh] text-center text-white bg-gradient-to-b from-[#0075ff] to-[#003aa2]">
        <img src="svg/logo-blanco.svg" class="w-[130px]" alt="Logo Fincomercio" />
        <label class="text-3xl font-bold">Asóciate a</label>
        <label class="text-[1.3rem] font-medium mb-4 uppercase">
            Cooperativa de ahorro y crédito fincomercio ltda.
        </label>
    </div>
    <div class="bg-white h-[60vh] flex flex-col w-screen mt-0">

        @if(consultor() !== null) {
            <div class="flex justify-end  w-auto h-6 bg-white -mt-1">
                <label class="text-white font-medium text-[10px] px-2 bg-gradient-to-b from-[#003aa2] to-[#0075ff] rounded-b-2xl" for="">
                    <b>Tu asesor:</b> {{ consultor()?.name  }}
                </label>
            </div>
        }
        <div class="h-full w-screen flex flex-col text-justify p-4 text-base text-gray-900">
        @if (consultor() !== null) {
            <label class="text-base font-sans mb-2 text-justify" for="information">
                Durante tu proceso de vinculación validaremos tu identidad con nuestro aliado Redeban-SoyYo.
            </label>
            <label class="text-base font-sans mb-2 text-justify" for="information">
                Recibirás mensajes para acompañarte durante el proceso. Por favor ten a la mano tu documento de identidad. 
                Si estás listo, por favor presiona el botón "Iniciar"
            </label>

            <div class="h-10 w-full flex items-center justify-center">
                <button type="button" class="btn-primary" (click)="next()">
                    Iniciar
                </button>
            </div>
        }@else {
            <label class="text-base font-sans mb-2 text-justify" for="information">
                Por favor solicita a tu Asesor Comercial el link o su QR para poder
                continuar con tu proceso de vinculación
            </label>
        }
        </div>
    </div>
</div>